import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.290662 0.295132C0.679949 -0.0966248 1.31311 -0.0986263 1.70487 0.290662C3.48109 2.05569 6.24098 4.80627 8.55637 7.11515C9.71416 8.26968 10.761 9.31393 11.5183 10.0695L12.0387 10.5888L22.4021 0.290661C22.7939 -0.0986263 23.4271 -0.0966247 23.8163 0.295132C24.2056 0.686889 24.2036 1.32005 23.8119 1.70934L12.7421 12.7093C12.3515 13.0975 11.7206 13.0968 11.3308 12.7078L12.0372 12C11.3308 12.7078 11.3309 12.7079 11.3308 12.7078L10.1057 11.4854C9.34847 10.7299 8.30179 9.68574 7.14415 8.53135C4.82868 6.2224 2.06995 3.47297 0.295132 1.70934C-0.0966248 1.32005 -0.0986263 0.686889 0.290662 0.295132Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.8163 23.7049C23.427 24.0966 22.7938 24.0986 22.4021 23.7093C20.6258 21.9443 17.866 19.1937 15.5506 16.8849C14.3928 15.7303 13.346 14.6861 12.5886 13.9305L12.0682 13.4112L1.7048 23.7093C1.31304 24.0986 0.679876 24.0966 0.290588 23.7049C-0.0986995 23.3131 -0.0966967 22.6799 0.295059 22.2907L11.3648 11.2907C11.7554 10.9025 12.3863 10.9032 12.7761 11.2922L12.0697 12C12.7761 11.2922 12.776 11.2921 12.7761 11.2922L14.0012 12.5146C14.7585 13.2701 15.8051 14.3143 16.9628 15.4686C19.2783 17.7776 22.037 20.527 23.8118 22.2907C24.2036 22.6799 24.2056 23.3131 23.8163 23.7049Z"
    }, null, -1)
  ]))]))
}
export default { render: render }